import { useMemo } from "react";
import styled from "styled-components";

const HalligalliCard = ({ label, value, id }) => {
  const center = value % 2; // 0 or 1

  const sideBlocks = useMemo(() => {
    const side = Math.floor(value / 2) * 2;
    let arr = [];
    for (let i = 1; i <= side; i++) {
      arr.push(
        <ContentBox style={styles[i]} key={`${i}${id}halligalliKey`}>
          {label}
        </ContentBox>
      );
    }
    return arr;
  }, [id, value, label]);

  return (
    <CardWrap>
      {sideBlocks}
      {center ? (
        <ContentBox style={styles["center"]}>{label}</ContentBox>
      ) : null}
    </CardWrap>
  );
};
export default HalligalliCard;

const CardWrap = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`;
const ContentBox = styled.div`
  width: 17px;
  height: 17px;
  border: 1px solid #e0e0e0;
  display: flex;
  font-size: 12px;
  color: #242424;
  justify-content: center;
  align-items: center;
`;

const styles = {
  1: { position: "absolute", left: 0, top: 0 },
  2: { position: "absolute", right: 0, bottom: 0 },
  3: { position: "absolute", right: 0, top: 0 },
  4: { position: "absolute", left: 0, bottom: 0 },
  center: {
    position: "absolute",
    left: "50%",
    top: "50%",
    translate: "-50% -50%",
  },
};
